import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthPromptService } from '../services/auth-prompt.service';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const authPrompt = inject(AuthPromptService);

  // Check if we already know the user is logged in
  if (auth.isLoggedIn()) return true;

  // Check with the server (first load / page refresh)
  try {
    const res: any = await auth.checkStatus().toPromise();
    if (res.loggedIn && res.user) return true;
  } catch { /* not logged in */ }

  authPrompt.prompt();
  router.navigate(['/']);
  return false;
};
